import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import { closeWrapper } from './modalCloseIcon.css';

import { clsx } from 'clsx';
import { IconButton } from '../button/iconButton';
import { IconProp } from '@fortawesome/fontawesome-svg-core';

export type ModalCloseButtonProps = {
  onClick: () => void;
  className?: string;
  showCloseIcon?: boolean;
  testId?: string;
  customIcon?: IconProp;
};

export const ModalCloseButton = (p: ModalCloseButtonProps) => (
  <IconButton
    onClick={p.onClick}
    icon={p?.customIcon || faTimes}
    variant="text"
    color="neutral"
    className={clsx(closeWrapper, p.className)}
    data-testid={p?.testId && `close-${p.testId}`}
  />
);
